// extracted by mini-css-extract-plugin
module.exports = {"icon":"modal-warning_icon__3yD9f","message":"modal-warning_message__2UQad"};